import { html } from 'lit';
import { sectionHeading } from '../components/sectionHeading.js';
import type { LandingContent } from '../../shared/content/landingContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const benefitsSection = (content: LandingContent, editor?: LandingEditorRenderOptions) => html`
  <section
    id="vorteile"
    class=${editorNodeClass(editor, 'section.benefits', 'vp-section vp-benefits-section')}
    style=${editorNodeStyle(editor, 'section.benefits')}
    @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'section.benefits', event)}
    @click=${(event: MouseEvent) => editorNodeClick(editor, 'section.benefits', event)}
  >
    <div class="vp-shell">
      ${sectionHeading({
        eyebrow: content.benefits.eyebrow,
        title: content.benefits.title,
        highlight: content.benefits.titleHighlight,
        align: 'center',
        editor,
        elementPrefix: 'benefits',
      })}
      <div
        class=${editorNodeClass(editor, 'benefits.items.container', 'vp-benefit-grid')}
        style=${editorNodeStyle(editor, 'benefits.items.container')}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, 'benefits.items.container', event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, 'benefits.items.container', event)}
      >
        ${content.benefits.items.map(
          (item, index) => html`
            <article
              class=${editorNodeClass(editor, `benefits.item.${index}`, 'vp-benefit-item reveal-card')}
              style=${editorNodeStyle(editor, `benefits.item.${index}`)}
              @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `benefits.item.${index}`, event)}
              @click=${(event: MouseEvent) => editorNodeClick(editor, `benefits.item.${index}`, event)}
            >
              <span
                class=${editorNodeClass(editor, `benefits.item.${index}.icon`, item.iconClass)}
                style=${editorNodeStyle(editor, `benefits.item.${index}.icon`)}
                @pointerdown=${(event: PointerEvent) =>
                  editorNodePointerDown(editor, `benefits.item.${index}.icon`, event)}
                @click=${(event: MouseEvent) => editorNodeClick(editor, `benefits.item.${index}.icon`, event)}
              ></span>
              <div>
                ${editorSemanticText({
                  editor,
                  elementId: `benefits.item.${index}.title`,
                  fallbackTag: 'h3',
                  content: item.title,
                })}
                ${editorSemanticText({
                  editor,
                  elementId: `benefits.item.${index}.text`,
                  fallbackTag: 'p',
                  content: item.text,
                })}
              </div>
            </article>
          `,
        )}
      </div>
    </div>
  </section>
`;
